import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Admin from "./components/Admin";
import DiagnosticExperience from "./components/DiagnosticExperience";
import RequireAuth from "./components/RequireAuth";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function RootRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const routeParam = params.get("route");

  const routeMap = {
    admin: "/admin",
    diagnostic: "/diagnostic",
    "diagnostic/en": "/diagnostic?lang=en",
    "diagnostic/ch": "/diagnostic?lang=ch",
    "diagnostic/th": "/diagnostic?lang=th",
    "diagnostic/ja": "/diagnostic?lang=ja",
    "diagnostic/pre": "/diagnostic",
    "diagnostic/post": "/diagnostic",
    "diagnostic/pre/en": "/diagnostic?lang=en&variant=pre",
    "diagnostic/pre/ch": "/diagnostic?lang=ch&variant=pre",
    "diagnostic/pre/th": "/diagnostic?lang=th&variant=pre",
    "diagnostic/pre/ja": "/diagnostic?lang=ja&variant=pre",
    "diagnostic/post/en": "/diagnostic?lang=en&variant=post",
    "diagnostic/post/ch": "/diagnostic?lang=ch&variant=post",
    "diagnostic/post/th": "/diagnostic?lang=th&variant=post",
    "diagnostic/post/ja": "/diagnostic?lang=ja&variant=post",
  };

  if (routeParam && routeMap[routeParam]) {
    return <Navigate to={routeMap[routeParam]} replace />;
  }

  return <Navigate to="/diagnostic" replace />;
}

function LegacyDiagnosticRedirect({ defaultVariant = "post" }) {
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  const segments = pathname.split("/").filter(Boolean);
  const lang = segments[segments.length - 1];
  const normalizedLang = ["en", "ch", "th", "ja"].includes(lang) ? lang : "en";

  const nextParams = new URLSearchParams();
  nextParams.set("lang", normalizedLang);
  nextParams.set("variant", defaultVariant);

  const code = params.get("code");
  if (code) {
    nextParams.set("code", code);
  }

  return <Navigate to={`/diagnostic?${nextParams.toString()}`} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <Admin />
            </RequireAuth>
          }
        />
        <Route path="/" element={<RootRedirect />} />
        <Route path="/diagnostic" element={<DiagnosticExperience />} />
        <Route path="/start" element={<DiagnosticExperience />} />
        <Route path="/diagnostic/pre" element={<Navigate to="/diagnostic" replace />} />
        <Route path="/diagnostic/post" element={<Navigate to="/diagnostic" replace />} />
        <Route path="/diagnostic/:lang" element={<LegacyDiagnosticRedirect />} />
        <Route
          path="/diagnostic/pre/:lang"
          element={<LegacyDiagnosticRedirect defaultVariant="pre" />}
        />
        <Route
          path="/diagnostic/post/:lang"
          element={<LegacyDiagnosticRedirect defaultVariant="post" />}
        />
        <Route path="*" element={<Navigate to="/diagnostic" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
